import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IonSpinner } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'dojo-submission-spinner-dialog',
  standalone: true,
  imports: [IonSpinner, TranslocoPipe],
  template: `
    <div class="flex flex-col items-center justify-center p-8">
      <ion-spinner name="crescent" class="mb-6 h-12 w-12 text-sky-500" />
      <p class="text-primary text-lg font-medium">
        {{ 'challenge.submitting_answers' | transloco }}
      </p>
      <p class="text-secondary mt-2 text-sm">
        {{ 'challenge.submitting_answers_description' | transloco }}
      </p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubmissionSpinnerDialogComponent {}
